import { format_ShortDOW_Date, getFormattedTimeStamp, getShiftTime } from "./dateTimeFormatter";
import { getTORPreferredLeaveTime } from "./timeOffExportMapper";

var FlexSearch = require("flexsearch");

var index;

export function initializeSearchIndex(timeOffRequests, isAdminPage) {
  if (isAdminPage) {
    index = new FlexSearch({
      doc: {
        id: "torId",
        profile: "speed",
        field: {
          lastUpdatedDate: {},
          timeOffRequestType: {},
          visibleStatus: {},
          empFirstName: {},
          empLastName: {},
          empId: {},
          empWorkgroup: {},
          shiftStart: {},
          shiftEnd: {},
        },
      },
    });
  } else {
    index = new FlexSearch({
      doc: {
        id: "torId",
        profile: "speed",
        field: {
          lastUpdatedDate: {},
          timeOffRequestType: {},
          visibleStatus: {},
          empFirstName: {},
          empLastName: {},
          empId: {},
          empWorkgroup: {},
          shiftStart: {},
          shiftEnd: {},
        },
      },
    });
  }

  index.add(timeOffRequests);
}

export function initializeWOPSearchIndex(timeOffRequests, isAdminPage) {
  if (isAdminPage) {
    index = new FlexSearch({
      doc: {
        id: "torId",
        profile: "speed",
        field: {
          submittedDate: {},
          approvedDate: {},
          visibleStatus: {},
          empFirstName: {},
          empLastName: {},
          empId: {},
          empWorkgroup: {},
          shiftStart: {},
          shiftEnd: {},
          rank: {},
          preferredWOPStart: {},
          preferredWOPEnd: {},
          approvedWOPStart: {},
          approvedWOPEnd: {},
          phoneNumber: {},
        },
      },
    });
  } else {
    index = new FlexSearch({
      doc: {
        id: "torId",
        profile: "speed",
        field: {
          submittedDate: {},
          approvedDate: {},
          visibleStatus: {},
          empFirstName: {},
          empLastName: {},
          empId: {},
          empWorkgroup: {},
          shiftStart: {},
          shiftEnd: {},
          rank: {},
          preferredWOPStart: {},
          preferredWOPEnd: {},
          approvedWOPStart: {},
          approvedWOPEnd: {},
        },
      },
    });
  }
  index.add(timeOffRequests);
}

export function searchTimeOffRequests(searchString, applySearchCallback, isAdminPage) {
  if (index) {
    let result = index.where(
      function (item) {
        if (getFormattedTimeStamp(item.lastUpdatedDate).includes(searchString)) {
          return true;
        }

        if (item.timeOffRequestType.toLowerCase().includes(searchString.toLowerCase())) {
          return true;
        }

        if (item.visibleStatus.toLowerCase().includes(searchString.toLowerCase())) {
          return true;
        }

        const employee = item.empLastName + ", " + item.empFirstName + " (" + item.empId + ") - " + item.empWorkgroup;
        if (employee.toLowerCase().includes(searchString.toLowerCase())) {
          return true;
        }

        const employeeShift =
          format_ShortDOW_Date(item.shiftStart) +
          " " +
          getShiftTime(item.shiftStart) +
          "-" +
          getShiftTime(item.shiftEnd);
        if (employeeShift.toLowerCase().includes(searchString.toLowerCase())) {
          return true;
        }

        return false;
      },
      (result) => {
        applySearchCallback(searchString, result);
      }
    );
    applySearchCallback(searchString, result);
  }
}

export function searchTimeOffRequestsWOP(searchString, applySearchCallback) {
  if (index) {
    let result = index.where(
      function (item) {
        const date = item.submittedDate ? item.submittedDate : item.approvedDate;
        const formattedDate = format_ShortDOW_Date(date) + " " + getShiftTime(date);
        if (formattedDate.includes(searchString)) {
          return true;
        }

        if (item.visibleStatus.toLowerCase().includes(searchString.toLowerCase())) {
          return true;
        }

        if (item.rank.toString().toLowerCase().includes(searchString.toLowerCase())) {
          return true;
        }

        if (item.phoneNumber.toLowerCase().includes(searchString.toLowerCase())) {
          return true;
        }

        const preferredLeaveTime = getTORPreferredLeaveTime(item);
        if (preferredLeaveTime.toLowerCase().includes(searchString.toLowerCase())) {
          return true;
        }

        if (item.approvedWOPEnd.toLowerCase().includes(searchString.toLowerCase())) {
          return true;
        }

        if (item.approvedWOPStart.toLowerCase().includes(searchString.toLowerCase())) {
          return true;
        }

        const employee = item.empLastName + ", " + item.empFirstName + " (" + item.empId + ") - " + item.empWorkgroup;
        if (employee.toLowerCase().includes(searchString.toLowerCase())) {
          return true;
        }

        const employeeShift =
          format_ShortDOW_Date(item.shiftStart) +
          " " +
          getShiftTime(item.shiftStart) +
          "-" +
          getShiftTime(item.shiftEnd);
        if (employeeShift.toLowerCase().includes(searchString.toLowerCase())) {
          return true;
        }

        return false;
      },
      (result) => {
        applySearchCallback(searchString, result);
      }
    );
    applySearchCallback(searchString, result);
  }
}
